(function(){
  'use strict';
  if (window.__schiekKitGiftSyncLoaded) return;
  window.__schiekKitGiftSyncLoaded = true;

  var GIFT_PRODUCT_ID = 8338113495336;
  var GIFT_VARIANT_ID = 45353748365608;

  var KITS = {
    'General Fitness Essential Kit': [8336059695400,8801925267752,10405956682024],
    'General Fitness Pro Kit': [8338114609448,8801925267752,8338113888552],
    'Muscle Essential Kit': [8303613477160,8801925267752],
    'Muscle Pro Kit': [9872896819496,8801925267752,8338113429800],
    'Performance Essential Kit': [8303613477160,8801925267752],
    'Performance Pro Kit': [8338114609448,8338113167656,8338112741672],
    'Strength Essential Kit': [8336059695400,8801925267752,8880382312744],
    'Strength Pro Kit': [9872896819496,8801925267752,8338112938280]
  };

  var syncing = false;
  var timer = null;

  function prop(item,key){
    return item && item.properties ? item.properties[key] : null;
  }

  function cartRoot(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getCart(){
    return fetch(cartRoot() + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(r){return r.json();});
  }

  function post(path, body){
    return fetch(cartRoot() + path, {
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){return r.json().then(function(data){ if(!r.ok) throw new Error(data.description||data.message||'Cart update failed'); return data; });});
  }

  function kitNamesInCart(cart){
    var names = [];
    (cart.items||[]).forEach(function(item){
      var name = prop(item,'_kit');
      if(name && names.indexOf(name) === -1) names.push(name);
    });
    return names;
  }

  function completeForKit(cart, kitName){
    var required = KITS[kitName];
    if(!required) return false;
    return required.every(function(id){
      return (cart.items||[]).some(function(item){
        return Number(item.product_id) === id && prop(item,'_kit') === kitName;
      });
    });
  }

  function giftLine(cart, kitName){
    return (cart.items||[]).find(function(item){
      return Number(item.product_id) === GIFT_PRODUCT_ID && prop(item,'_kit') === kitName;
    });
  }

  function autoGiftLine(cart, kitName){
    return (cart.items||[]).find(function(item){
      return Number(item.product_id) === GIFT_PRODUCT_ID &&
        prop(item,'_kit') === kitName &&
        String(prop(item,'_kit_gift')) === 'true';
    });
  }

  function refreshUI(){
    document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
  }

  function sync(){
    if(syncing) return;
    syncing = true;
    getCart().then(function(cart){
      var names = kitNamesInCart(cart);
      var add = null, remove = null, replaceGift = null;

      names.some(function(name){
        if(!KITS[name]) return false;
        var complete = completeForKit(cart,name);
        var gift = giftLine(cart,name);
        if(complete && !gift){
          add = {name:name};
          return true;
        }
        if(complete && gift && String(prop(gift,'_kit_gift')) !== 'true'){
          replaceGift = {key:gift.key,name:name};
          return true;
        }
        var autoGift = autoGiftLine(cart,name);
        if(!complete && autoGift){
          remove = {key:autoGift.key};
          return true;
        }
        return false;
      });

      if(replaceGift){
        return post('cart/change.js',{id:replaceGift.key,quantity:0})
          .then(function(){
            return post('cart/add.js',{
              items:[{
                id:GIFT_VARIANT_ID,
                quantity:1,
                properties:{_kit:replaceGift.name,_kit_gift:'true'}
              }]
            });
          })
          .then(function(){ refreshUI(); });
      }
      if(add){
        return post('cart/add.js',{
          items:[{
            id:GIFT_VARIANT_ID,
            quantity:1,
            properties:{_kit:add.name,_kit_gift:'true'}
          }]
        }).then(function(){ refreshUI(); });
      }
      if(remove){
        return post('cart/change.js',{id:remove.key,quantity:0}).then(function(){ refreshUI(); });
      }
    }).catch(function(){}).then(function(){ syncing=false; });
  }

  function schedule(){
    clearTimeout(timer);
    timer=setTimeout(sync,120);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',schedule);
  else schedule();
  document.addEventListener('ajaxProduct:added',schedule);
  document.addEventListener('cart:updated',schedule);
  document.addEventListener('shopify:section:load',schedule);
})();
(function () {
  'use strict';
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form || (form.id !== 'CartDrawerForm' && form.id !== 'CartPageForm')) return;
    var button = event.submitter;
    if (!button || !button.hasAttribute('data-customsirge-native-checkout')) return;
    if (!form.querySelector('[data-discounts] .is-quiz')) return;
    event.preventDefault();
    if (form.dataset.checkoutPending === 'true') return;
    form.dataset.checkoutPending = 'true';
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var target = base + 'checkout?discount=' + encodeURIComponent('SCHIEKQUIZLEVELUP');
    var note = form.querySelector('[name="note"]');
    function go() { window.location.assign(target); }
    if (!note || note.value === note.defaultValue) {
      go();
      return;
    }
    fetch(base + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({note:note.value, discount:'SCHIEKQUIZLEVELUP'})
    }).then(function (response) {
      if (!response.ok) throw new Error('Your order note could not be saved. Please try checkout again.');
      go();
    }).catch(function (error) {
      delete form.dataset.checkoutPending;
      button.classList.remove('btn--loading');
      var message = form.querySelector('[data-checkout-error]');
      if (!message) {
        message = document.createElement('p');
        message.setAttribute('data-checkout-error', '');
        message.setAttribute('role', 'alert');
        button.parentNode.appendChild(message);
      }
      message.textContent = error.message;
    });
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-checkout-pending]').forEach(function (form) {
      delete form.dataset.checkoutPending;
    });
  });
})();
